import { render, staticRenderFns } from "./StepsSecond.vue?vue&type=template&id=37c8152c&scoped=true"
import script from "./StepsSecond.vue?vue&type=script&lang=js"
export * from "./StepsSecond.vue?vue&type=script&lang=js"
import style0 from "./StepsSecond.vue?vue&type=style&index=0&id=37c8152c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c8152c",
  null
  
)

export default component.exports